"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Components = __importStar(require("../components"));
var react_1 = require("react");
exports.Renderer = function (root, blocks, plugins) {
    var rootBlock = blocks[root];
    if (!root || (!rootBlock.type && rootBlock.type !== "Module")) {
        throw new Error("Root block must be of type module");
    }
    var parsedPlugins;
    if (!plugins) {
        parsedPlugins = [];
    }
    else if (Array.isArray(plugins)) {
        parsedPlugins = plugins;
    }
    else {
        throw new Error("plugins must be undefined or an array of plugin objects");
    }
    var renderRoot = function () {
        return render(rootBlock);
    };
    var render = function (block) {
        if (!block) {
            throw new Error("block must be not null");
        }
        if (block.type === "Ref") {
            block = blocks[block.id];
        }
        var children = block.children;
        if (!children) {
            children = null;
        }
        else if (children && Array.isArray(children)) {
            children = children.map(render);
        }
        var animator = {};
        if (block.animator) {
            animator.animator = Components[block.animator.type];
            animator.config = block.animator.config;
        }
        var element = react_1.createElement(Components[block.type], __assign(__assign({ key: Math.random(), children: children }, block.props), animator));
        var _a = parsedPlugins.reduce(function (_a, fn) {
            var block = _a[0], element = _a[1];
            return fn.onRenderedBlock(block, element);
        }, [block, element]), _ = _a[0], renderedElement = _a[1];
        return renderedElement;
    };
    return {
        render: render,
        renderRoot: renderRoot
    };
};
exports.editorPlugin = {
    onRenderedBlock: function (block, element) {
        if (element.type.editableFields) {
            return [
                block,
                react_1.createElement(Components.Editable, {
                    block: block,
                    key: "edit-" + block.id,
                    children: react_1.cloneElement(element)
                })
            ];
        }
        return [block, element];
    }
};
